import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { bool, func } from "prop-types";
import debounce from "lodash.debounce";
import { formFieldPropTypes } from "../../shared/propTypes";
var NAME = "note";

var Note = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Note, _Component);

  function Note() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleOnChangeDebounced = debounce(function (e) {
      var updateFormField = _this.props.updateFormField;
      var value = e.target.value ? e.target.value.trim() : "";
      updateFormField(NAME, {
        value: value,
        isTouched: true
      });
    }, 500);

    _this.handleOnChange = function (e) {
      e.persist();

      _this.handleOnChangeDebounced(e);
    };

    return _this;
  }

  var _proto = Note.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _this$props$note = _this$props.note,
        isRequired = _this$props$note.isRequired,
        isTouched = _this$props$note.isTouched,
        value = _this$props$note.value,
        formSubmitAttempted = _this$props.formSubmitAttempted;
    var showError = (isTouched || formSubmitAttempted) && isRequired && !value;
    var formGroupClasses = ["form-group", showError ? "has-error" : ""].join(" ");
    return /*#__PURE__*/React.createElement("div", {
      className: formGroupClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "control-label"
    }, "Full Description of this Change")), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/React.createElement("textarea", {
      className: "form-control",
      name: NAME,
      defaultValue: value,
      required: isRequired,
      onChange: this.handleOnChange,
      placeholder: "e.g. Insured added a new garage and requested additional coverage."
    }), showError && /*#__PURE__*/React.createElement("p", {
      className: "help-block"
    }, "Please supply details for this policy update.")));
  };

  return Note;
}(Component);

Note.propTypes = {
  note: formFieldPropTypes,
  formSubmitAttempted: bool.isRequired,
  updateFormField: func.isRequired
};
export { Note as default };